import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatDateTime } from "@/lib/datetime";
import { Ban } from "lucide-react";

const SHOWN = 3;

/** REFUSED UPLOADS — every file this place turned away: name, type, when, who and the plain reason.
 *  The last few at a glance; "Show all" opens the full list. Nothing shows when none were refused. */
export function RefusedUploads({ params, refreshKey = 0, testid = "refused-uploads" }) {
  const [data, setData] = useState(null);
  const [all, setAll] = useState(false);
  const qs = new URLSearchParams(params).toString();

  useEffect(() => {
    const limit = all ? Math.max(data?.total || 0, SHOWN) : SHOWN;
    api.get(`/upload-refusals?${qs}&limit=${limit}`).then(({ data }) => setData(data)).catch(() => setData(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qs, refreshKey, all]);

  const rows = data?.rows || [];
  if (!rows.length) return null;
  return (
    <div data-testid={testid} className="rounded-lg border border-red-200 bg-red-50/40 px-3 py-2 text-[12px]">
      <p data-testid={`${testid}-title`} className="flex items-center gap-1.5 font-semibold text-[#8B1820]">
        <Ban className="w-3.5 h-3.5" />Refused uploads · {data.total}
      </p>
      <ul className={`mt-1.5 divide-y divide-red-100 ${all ? "max-h-80 overflow-y-auto pr-1" : ""}`}>
        {rows.map((r) => <RefusedRow key={r.id} r={r} testid={testid} />)}
      </ul>
      {data.total > SHOWN && (
        <button type="button" data-testid={`${testid}-toggle`} onClick={() => setAll((v) => !v)}
          className="mt-1 text-[11px] font-semibold text-[#B01E28] hover:underline">
          {all ? "Show fewer" : `Show all ${data.total}`}
        </button>
      )}
    </div>
  );
}

function RefusedRow({ r, testid }) {
  return (
    <li data-testid={`${testid}-row`} className="py-1.5 space-y-0.5">
      <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
        <span data-testid={`${testid}-reason`} className="font-semibold text-slate-900">{r.reason_label}</span>
        <span data-testid={`${testid}-file`} className="font-mono text-[11px] text-slate-700 break-all">{r.file_name}</span>
        <span className="text-[11px] text-slate-500">{r.file_type}</span>
      </div>
      <p className="text-[11px] text-slate-500">
        <span data-testid={`${testid}-when`}>{formatDateTime(r.at)}</span> · <span data-testid={`${testid}-who`}>{r.by}</span>
        {r.where_label ? <> · {r.where_label}</> : null}
      </p>
      <p data-testid={`${testid}-why`} className="text-[11px] text-slate-600">{r.reason}</p>
    </li>
  );
}
